import React from 'react'
import { Badge } from 'reactstrap'

type IsActiveBadgeProps = {
  isActive?: boolean
}

const IsActiveBadge: React.FC<IsActiveBadgeProps> = ({ isActive }) => {
  return isActive ? (
    <Badge color="success">Yes</Badge>
  ) : (
    <Badge color="danger">No</Badge>
  )
}

export default IsActiveBadge
